export default {
  "validations": {
    "required": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["The field ", _interpolate(_named("property")), " is required."])},
    "minLength": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["The ", _interpolate(_named("property")), " field has a value of '", _interpolate(_named("model")), "', but it must have a min length of ", _interpolate(_named("min")), "."])}
  }
}